import { Button } from '@insight-health-ai/roseate/components';
import { Check, ArrowRight } from '@insight-health-ai/roseate/icons';
import classNames from 'classnames';
import type { FormBlock } from '../types';

type SubmitButtonBlock = FormBlock & {
  label: string;
  icon?: 'check' | 'arrow_right';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
};
import { useEditingContext } from '../FormProvider';

const ICONS: Record<string, React.ReactNode> = {
  check: <Check />,
  arrow_right: <ArrowRight />,
};

export function SubmitButton({ block }: { block: SubmitButtonBlock }) {
  const { submitting } = useEditingContext();

  return (
    <div
      className={classNames(
        block.fullWidth ? '' : 'flex justify-center',
        block.className
      )}
    >
      <Button
        block={block.fullWidth}
        size={block.size ?? 'lg'}
        type="submit"
        loading={submitting}
        disabled={submitting}
        icon={block.icon ? ICONS[block.icon] : undefined}
        label={block.label}
      />
    </div>
  );
}
